import styled from "styled-components"

export const Container = styled.main `

  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 80px calc(100% - 80px);

`